export default function initMenu() {
  Alpine.data('menu', () => ({
    navActive: false,
    searchActive: false,

    init() {
      this.$watch('navActive', () => {this.$root.classList.toggle('nav-active', this.navActive);});
      this.$watch('searchActive', () => {this.$root.classList.toggle('search-active', this.searchActive);});

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.searchActive) {
            this.searchActive = false;
          }
          if (this.navActive) {
            this.navActive = false;
          }
        }
      });
    },

    open() {
      // @ts-ignore
      const event = this.$event;
      if (window.matchMedia('(min-width: 64rem)').matches || event instanceof PointerEvent) {
        this.navActive = true;
        const navItems = document.getElementsByClassName('group/link-nav');
        Array.from(navItems).forEach((item) => {
          item.classList.remove('active-drop');
        });
        if (this.$el.classList.contains('group/link-nav')) {
          this.$el.classList.add('active-drop');
          const menuDrop = this.$el.querySelector('button') as HTMLElement;
          menuDrop.ariaExpanded = 'true';
        } else {
          this.$el.parentElement?.classList.add('active-drop');
          this.$el.ariaExpanded = 'true';
        }
      }
    },

    close() {
      if (window.matchMedia('(min-width: 64rem)').matches) {
        this.navActive = false;
        const navItems = document.getElementsByClassName('group/link-nav');
        Array.from(navItems).forEach((item) => {
          item.classList.remove('active-drop');
        });
        if (this.$el.classList.contains('group/link-nav')) {
          const menuDrop = this.$el.querySelector('button') as HTMLElement;
          menuDrop.ariaExpanded = 'false';
        } else {
          this.$el.ariaExpanded = 'false';
        }
      }
    },

    toggle() {
      // @ts-ignore
      const event = this.$event as KeyboardEvent;
      if (event.code === 'Enter' || event.code === 'Space') {
        if (!this.navActive) {
          this.open();
        } else {
          if (this.$el.parentElement?.classList.contains('active-drop')) {
            this.close();
          } else {
            const navItems = document.getElementsByClassName('group/link-nav');
            Array.from(navItems).forEach((item) => {
              item.classList.remove('active-drop');
              const menuDrop = item.querySelector('button') as HTMLElement|null;
              if (menuDrop) {
                menuDrop.ariaExpanded = 'false';
              }
            });
            this.$el.parentElement?.classList.add('active-drop');
            this.$el.ariaExpanded = 'true';
          }
        }
      }
    },

    mobileOpen() {
      this.navActive = true;
      this.$el.ariaExpanded = 'true';
    },

    mobileClose() {
      this.navActive = false;
    },

    mobileBack() {
      const navItems = document.getElementsByClassName('group/link-nav');
      Array.from(navItems).forEach((item) => {
        item.classList.remove('active-drop');
        const menuDrop = item.querySelector('button') as HTMLElement|null;
        if (menuDrop) {
          menuDrop.ariaExpanded = 'false';
        }
      });
    },

    openSearch() {
      // @ts-ignore
      const event = this.$event as KeyboardEvent|PointerEvent;
      if (
        (event instanceof KeyboardEvent && (event.code === 'Enter' || event.code === 'Space')) ||
        event instanceof PointerEvent
      ) {
        this.searchActive = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.searchInput?.focus();
          }, 20); // We have to wait for the DOM to be updated so that the searchInput is focusable
        });
      }
    },

    closeSearch() {
      // @ts-ignore
      const event = this.$event as KeyboardEvent|PointerEvent;
      if (event instanceof KeyboardEvent && (event.code === 'Enter' || event.code === 'Space')) {
        this.searchActive = false;
      } else if (event instanceof PointerEvent) {
        this.searchActive = false;
      }
    },
  }))
}
